import { Injectable } from '@angular/core';
import { CapacitorSQLite, SQLiteConnection, SQLiteDBConnection, CapacitorSQLitePlugin,
  capSQLiteUpgradeOptions, capSQLiteResult, capSQLiteValues} from '@capacitor-community/sqlite';
import { Capacitor } from '@capacitor/core';


@Injectable({
  providedIn: 'root'
})
export class DatabaseService {

  private sqlite: SQLiteConnection;
  private db: SQLiteDBConnection | null = null;

  dbName:string = 'cmcDB'

  initialised = false

  isNative = Capacitor.isNativePlatform();

  constructor() { 

 

    this.sqlite = new SQLiteConnection(CapacitorSQLite);
  }


     /**
     * Initialize the Web store
     * @param database 
     */
     async initWebStore(): Promise<void> {
  if ( Capacitor.isNativePlatform() ){

          return Promise.reject(new Error(`not implemented for this platform`));
      }
      if(this.sqlite != null) {
          try {
              await this.sqlite.initWebStore();
       
              return Promise.resolve();
          } catch (err) {
              return Promise.reject(new Error(err));
          }
      } else {
          return Promise.reject(new Error(`no connection open`));
      }
  }


  async initializeDatabase() {


    try {
      // Check connection consistency
      const retCC = (await this.sqlite.checkConnectionsConsistency()).result;

      // Check is connected
      const isConnection = (await this.sqlite.isConnection(this.dbName, false)).result;

   
        // Create a new connection
        this.db = await this.sqlite.createConnection(this.dbName, false, 'no-encryption', 1, false);
      if (!this.db){
         return 'Database connection is not open';
      }

      this.initialised = true

      // Open the database
       let opened = await this.db.open()

        await this.createTables();
         return 'opened'

    } catch (error) {
      console.error('Error initializing the database:', error);

      return error;
    }
  }



  private async createTables(){

    if (!this.db) throw new Error('Database connection is not open');
    //await this.sqlite.saveToStore(this.dbName);
/* event timing table */
    let schema = 'CREATE TABLE IF NOT EXISTS finish_times ( id INTEGER PRIMARY KEY AUTOINCREMENT, time INTEGER NOT NULL)';
    await this.db.execute(schema);

    /* event timing table*/
    schema = 'CREATE TABLE IF NOT EXISTS barcodes ( id INTEGER PRIMARY KEY AUTOINCREMENT, user INTEGER NOT NULL, position INTEGER NOT NULL)';
    await this.db.execute(schema); 

    return 'opened'
  }

  async addTime( time: number): Promise<void> {
   
    if (!this.db){
      console.log('Database connection is not open')
      return Promise.reject(new Error('Database connection is not open'));
    } 

    const insertQuery =  `INSERT INTO finish_times (id,time) VALUES (NULL, ${time})`;
    console.log('QUERY  ',insertQuery)
    try{

  let query = await this.db.run(insertQuery);
  await this.sqlite.saveToStore(this.dbName);
    console.log('QUERY  ',query)
    }
   catch(e){
    //console.log('Error ',e)
   }


  }

  async clearTimes(): Promise<void> {

    if (!this.db){
      console.log('Database connection is not open')
      return Promise.reject(new Error('Database connection is not open'));
    } 
    const empty = `
    DELETE FROM finish_times; `;
    await this.db.execute(empty);
    await this.sqlite.saveToStore(this.dbName);
  }


  async clearBarcodes(): Promise<void> {

    if (!this.db){
      console.log('Database connection is not open')
      return Promise.reject(new Error('Database connection is not open'));
    } 
    const empty = `
    DELETE FROM barcodes; `;
    await this.db.execute(empty);
    await this.sqlite.saveToStore(this.dbName);
  }
async addBarcode(user: any, position: any) {
  if (!this.db) {
    alert('Database connection is not open');
    return Promise.reject(new Error('Database connection is not open'));
  }
  const insertQuery = `INSERT INTO barcodes (id,user,position) VALUES (NULL,${user},${position})`;
  try {
    await this.db.run(insertQuery);
    if(!this.isNative){
        await this.sqlite.saveToStore(this.dbName);
    }
    return { user, position };
  } catch (e) {
    alert('Error saving barcode: ' + e);
    return Promise.reject(e);
  }
}
  async getTimes(): Promise<any[]> {
    if (!this.db) throw new Error('Database connection is not open');
   // await this.sqlite.saveToStore(this.dbName);
    const result = await this.db.query('SELECT * FROM finish_times');

  return result.values|| [];
  }

  async getBarcodes(): Promise<any[]> {
    if (!this.db) throw new Error('Database connection is not open');
   // await this.sqlite.saveToStore(this.dbName);
    const result = await this.db.query('SELECT * FROM barcodes');
    return result.values || [];
  }

  async closeDatabase(): Promise<void> {
    if (this.db) {
      
      await this.sqlite.closeConnection(this.dbName,false);
      this.db = null;
    }
  }


}
